export default {"src":"/_next/static/media/b.875c98e0.svg","height":161,"width":140};